import { render } from "./NavSideDropdown.vue?vue&type=template&id=28732e00&scoped=true"
import script from "./NavSideDropdown.vue?vue&type=script&lang=js"
export * from "./NavSideDropdown.vue?vue&type=script&lang=js"

import "./NavSideDropdown.vue?vue&type=style&index=0&id=28732e00&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28732e00"]])

export default __exports__